import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-payments',
  imports: [],
  templateUrl: './admin-payments.component.html',
  styleUrl: './admin-payments.component.scss',
})
export class AdminPaymentsComponent {

}
